const LANG_MAP = {
  'es': 'es', 'es-ES': 'es', 'es-MX': 'es', 'es-AR': 'es',
  'en': 'en', 'en-US': 'en', 'en-GB': 'en', 'en-AU': 'en', 'en-CA': 'en',
  'ca': 'ca', 'ca-ES': 'ca', 'ca-ES-valencia': 'ca',
  'fr': 'fr', 'fr-FR': 'fr', 'fr-CA': 'fr', 'fr-BE': 'fr', 'fr-CH': 'fr',
  'eu': 'eu', 'eu-ES': 'eu'
};

export const SUPPORTED_LANGS = ['es', 'en', 'ca', 'fr', 'eu'];

export const LANG_DISPLAY = {
  es: 'ES',
  en: 'EN',
  ca: 'CAT',
  fr: 'FR',
  eu: 'EUS'
};

export const LANG_NAMES = {
  es: 'Español',
  en: 'English',
  ca: 'Català',
  fr: 'Français',
  eu: 'Euskera'
};

export function detectBrowserLang() {
  const browserLangs = navigator.languages || [navigator.language || ''];
  for (const bl of browserLangs) {
    if (LANG_MAP[bl]) return LANG_MAP[bl];
  }
  const primary = browserLangs[0]?.slice(0, 2);
  return LANG_MAP[primary] || 'es';
}

export function detectInitialLang() {
  try {
    const saved = localStorage.getItem('ilu_lang');
    if (saved && SUPPORTED_LANGS.includes(saved)) return saved;
  } catch (e) {}
  return detectBrowserLang();
}

export function persistLang(lang) {
  try {
    localStorage.setItem('ilu_lang', lang);
  } catch (e) {}
}

export function getModulesForRoute(pathname) {
  const base = ['common', 'cookie', 'footer'];

  // En / se renderiza Main y puede mostrar Login si no hay sesión.
  if (!pathname || pathname === '/' || pathname.includes('@')) {
    base.push('login');
  }

  if (!pathname || pathname === '/' || pathname.includes('/home')) {
    base.push('home', 'menu');
  }
  if (pathname.includes('login') || pathname.includes('regist') || pathname.includes('restore')) {
    base.push('login');
  }
  if (pathname.includes('gift') || pathname.includes('list-gift')) {
    base.push('gift');
  }
  if (pathname.includes('movement') || pathname.includes('list-movements')) {
    base.push('movements');
  }
  if (pathname.includes('profile')) {
    base.push('profile');
  }
  if (pathname.includes('faq') || pathname.includes('frequent')) {
    base.push('faq');
  }
  if (pathname.includes('cookie') || pathname.includes('cookies')) {
    base.push('cookie');
  }
  if (pathname.includes('privacy') || pathname.includes('legal') || pathname.includes('aviso') || pathname.includes('warning')) {
    base.push('footer');
  }
  return [...new Set(base)];
}
